import { render, staticRenderFns } from "./MySwipe.vue?vue&type=template&id=40e9c1ba&scoped=true"
import script from "./MySwipe.vue?vue&type=script&lang=js"
export * from "./MySwipe.vue?vue&type=script&lang=js"
import style0 from "./MySwipe.vue?vue&type=style&index=0&id=40e9c1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e9c1ba",
  null
  
)

export default component.exports